import { newsFeed, editorPicks } from "@/mocks/news";

const rankColors = ["bg-primary-500", "bg-accent-500", "bg-foreground-600"];

export default function HotAndPicks() {
  const top = [...newsFeed].sort((a, b) => parseInt(b.views) - parseInt(a.views)).slice(0, 5);

  return (
    <section id="hot" className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* hot ranking */}
        <div className="lg:col-span-2">
          <div className="flex items-center justify-between mb-6">
            <div>
              <p className="text-primary-600 text-xs font-semibold tracking-[0.25em] mb-2">TRENDING · 现场热榜</p>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">此刻热度排行</h2>
            </div>
            <i className="ri-fire-fill text-2xl text-primary-500" />
          </div>

          <ol className="space-y-3">
            {top.map((item, i) => (
              <li
                key={item.id}
                className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 hover:bg-background-200/60 transition-colors cursor-pointer"
              >
                <span
                  className={`shrink-0 w-9 h-9 flex items-center justify-center rounded-md text-background-50 font-black ${
                    rankColors[i] || "bg-secondary-500"
                  }`}
                >
                  {i + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-bold text-[15px] text-foreground-950 line-clamp-1 leading-snug">{item.title}</h3>
                  <div className="mt-1 flex items-center gap-3 text-[11px] text-foreground-400">
                    <span className="text-primary-500 font-medium">{item.tag}</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-map-pin-2-line" /> {item.location}</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-eye-line" /> {item.views}</span>
                  </div>
                </div>
                <span className="hidden sm:block shrink-0 w-24 h-16 rounded-md overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                </span>
                <i className="ri-arrow-right-s-line text-foreground-300 shrink-0 text-xl" />
              </li>
            ))}
          </ol>
        </div>

        {/* editor picks */}
        <aside id="picks" className="scroll-mt-28">
          <div className="flex items-center justify-between mb-6">
            <div>
              <p className="text-accent-600 text-xs font-semibold tracking-[0.25em] mb-2">EDITOR'S PICKS · 编辑部精选</p>
              <h2 className="font-heading text-2xl font-bold text-foreground-950">深度与观察</h2>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {editorPicks.map((p) => (
              <article key={p.id} className="group rounded-lg overflow-hidden border border-background-200 bg-background-100 cursor-pointer">
                <a href="#picks" className="relative block aspect-[16/10] w-full overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" />
                  <span className="absolute top-2.5 left-2.5 rounded bg-accent-500 text-background-50 text-[10px] px-2 py-0.5">{p.tag}</span>
                </a>
                <div className="p-4">
                  <h3 className="font-heading font-bold text-[15px] text-foreground-950 leading-snug line-clamp-2 group-hover:text-accent-700">
                    {p.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-600 line-clamp-2">{p.excerpt}</p>
                  <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-400">
                    <span className="inline-flex items-center gap-1"><i className="ri-eye-line" /> {p.views} 阅读</span>
                    <span>{p.time}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
}